import React from "react";

const StatusWidget = ({ type, status, name, className, didReturn }) => {
  return (
    <div className="flex gap-1">
      <span
        className={`text-[11px] w-fit tracking-wider uppercase font-medium rounded-[25px] pl-[5px] pr-[5px] pb-[1px] pt-[2px] shadow-lg ${className} ${
          type === 3
            ? "text-gray-600 bg-gray-200"
            : status === 1
            ? "text-white bg-yellow-400"
            : "text-white bg-green-400"
        }`}
      >
        {name}
      </span>
      {didReturn && (
        <span className="text-[11px] w-fit tracking-wider uppercase font-medium rounded-[25px] pl-[5px] pr-[5px] pb-[1px] pt-[2px] shadow-lg bg-slate-400 text-white">
          Returned
        </span>
      )}
    </div>
  );
};

export default StatusWidget;
